var styles = {
  "light": "_light_ud38m4_6",
  "dark": "_dark_ud38m4_9",
  "flatRight": "_flatRight_ud38m4_13",
  "flatLeft": "_flatLeft_ud38m4_16",
  "sizeXs": "_sizeXs_ud38m4_20",
  "sizeS": "_sizeS_ud38m4_23",
  "sizeM": "_sizeM_ud38m4_26",
  "sizeL": "_sizeL_ud38m4_29",
  "modeClassic": "_modeClassic_ud38m4_33",
  "modeRock": "_modeRock_ud38m4_36",
  "modeTransparent": "_modeTransparent_ud38m4_39",
  "modeOutline": "_modeOutline_ud38m4_42",
  "modeClear": "_modeClear_ud38m4_45",
  "alignIconLeft": "_alignIconLeft_ud38m4_49",
  "alignIconLeftEdge": "_alignIconLeftEdge_ud38m4_52",
  "alignIconRight": "_alignIconRight_ud38m4_55",
  "alignIconRightEdge": "_alignIconRightEdge_ud38m4_58",
  "main": "_main_ud38m4_62",
  "disabled": "_disabled_ud38m4_139",
  "busy": "_busy_ud38m4_149",
  "busyOverlay": "_busyOverlay_ud38m4_153",
  "icon": "_icon_ud38m4_188",
  "allowMultiline": "_allowMultiline_ud38m4_203",
  "content": "_content_ud38m4_207",
  "multiline": "_multiline_ud38m4_213",
  "withoutText": "_withoutText_ud38m4_217",
  "busyIcon": "_busyIcon_ud38m4_222",
  "shiftedLeft": "_shiftedLeft_ud38m4_243",
  "shiftedRight": "_shiftedRight_ud38m4_246",
  "shiftedTop": "_shiftedTop_ud38m4_249",
  "shiftedBottom": "_shiftedBottom_ud38m4_252"
};
export { styles as default };
